import { render, staticRenderFns } from "./IcoFaceSmileHeart.vue?vue&type=template&id=1d55c412"
import script from "./IcoFaceSmileHeart.vue?vue&type=script&lang=js"
export * from "./IcoFaceSmileHeart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports